import { render, staticRenderFns } from "./salesShippingNotice-add-or-update.vue?vue&type=template&id=e5b631d8&scoped=true"
import script from "./salesShippingNotice-add-or-update.vue?vue&type=script&lang=js"
export * from "./salesShippingNotice-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./salesShippingNotice-add-or-update.vue?vue&type=style&index=0&id=e5b631d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b631d8",
  null
  
)

export default component.exports